<!--
 * @Author: guoyu
 * @Date: 2020-09-17 12:12:05
 * @LastEditors: your name
 * @LastEditTime: 2020-09-23 11:19:40
 * @Description: 調用app上傳
-->
<template>
  <div class="upload-container">
    <div
      class="upload-image"
      v-for="(item, index) in imageList"
      :key="index + 'img'"
    >
      <img @click="handlePreview(item)" :src="item" />
      <i class="cloes-icon el-icon-error" @click.stop="deleteImg(index)"></i>
    </div>
    <el-upload
      v-if="imageList.length < max"
      :http-request="uploadAction"
      action=""
      :show-file-list="false"
      :on-success="uploadImage"
    >
      <div class="upload-button"></div>
    </el-upload>
  </div>
</template>
<script>
import { uploadImageToS3 } from '@/api';
export default {
  model: {
    event: 'change',
    prop: 'val',
  },
  props: {
    val: {
      type: Array,
      default: () => [],
    },
    max: {
      type: [Number, String],
      default: 1,
    },
  },
  data() {
    return {
      uploadApi: process.env.VUE_APP_BASE_API + '/basic/image/upload',
    };
  },
  computed: {
    imageList: {
      get() {
        return this.val || [];
      },
      set(newVal) {
        this.$emit('change', newVal);
      },
    },
  },
  methods: {
    handlePreview(url) {
      const swipe = document.createElement('div');
      const img = document.createElement('img');

      swipe.setAttribute(
        'style',
        `
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
        padding: 15px 0;
        overflow: auto;
        z-index: 11110;
        background: rgba(255, 255, 255, 0.96);
      `
      );

      img.setAttribute('src', url);
      img.setAttribute(
        'style',
        `
        max-width: 100vw;
        max-height: 100vh;
        cursor: zoom-out;
        position: absolute;
        left: 50%;
        top: 50%;
        z-index: 11110;
        transform: translate3d(-50%, -50%, 0);
      `
      );

      swipe.appendChild(img);

      document.body.appendChild(swipe);
      document.body.setAttribute('style', 'overflow: hidden');

      const loading = this.$loading({
        target: swipe,
        customClass: 'pointer-events__none',
        background: 'rgba(255, 255, 255, 0)',
      });

      img.onload = () => {
        loading.close();
      };

      img.addEventListener('click', () => {
        document.body.removeChild(swipe);
        document.body.removeAttribute('style');
        loading.close();
      });
    },
    uploadAction({ file }) {
      const fd = new FormData();
      fd.append('file', file);
      return uploadImageToS3(fd);
    },
    uploadImage({ data }) {
      this.imageList.push(data);
    },
    deleteImg(index) {
      this.imageList.splice(index, 1);
    },
  },
};
</script>
<style lang="scss" scoped>
.upload-container {
  display: flex;
  flex-wrap: wrap;
}
.upload-image {
  position: relative;
  width: 103px;
  height: 103px;
  margin: 0 15px 15px 0;
  &:nth-child(3n) {
    margin-right: 0;
  }
  img {
    overflow: hidden;
    height: 100%;
    width: 100%;
    cursor: zoom-in;
    border-radius: 8px;
  }
}
.cloes-icon {
  display: none;
  position: absolute;
  top: 2px;
  right: 2px;
  font-size: 18px;
  color: #000000;
  cursor: pointer;
}
.upload-image:hover .cloes-icon {
  display: block;
}
.upload-button {
  position: relative;
  width: 103px;
  height: 103px;
  border: 1.5px dashed #dedede;
  border-radius: 8px;
  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 22px;
    height: 2px;
    background: #b5b5b5;
  }
  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 2px;
    height: 22px;
    background: #b5b5b5;
  }
}
</style>
